import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import { getBusinessDocumentData } from "config/documentData";
import { Formik, Form, Field } from "formik";
import React from "react";
import { useSelector } from "react-redux";
import _isEmpty from "lodash/isEmpty";
import _pick from "lodash/pick";

const Confirmation = ({
  agreeToSubmitToBrs,
  setAgreeToSubmitToBrs,
  goToNextStep,
}) => {
  const { company = {} } = useSelector((state) => state.companySlice);
  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={{
          fileUploads: company?.preSignedBusinessDocuments ?? {},
        }}
        onSubmit={goToNextStep}
      >
        {() => {
          return (
            <Form>
              {!_isEmpty(company?.preSignedBusinessDocuments ?? {}) ? (
                <div>
                  <div className="px-4 mt-4 space-y-6 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      File uploads
                    </h3>
                    <div className="space-y-2">
                      <Field
                        name="fileUploads"
                        component={FileUploadForm}
                        documentData={getBusinessDocumentData()}
                        onlyPreview
                        showDocumentLabel
                      />
                    </div>
                  </div>
                  <div className="flex my-4 align-middle">
                    <div className="flex items-center form-check">
                      <input
                        className="mr-4 align-top transition duration-200 bg-transparent bg-center bg-no-repeat bg-contain border rounded appearance-none cursor-pointer form-check-input border-tertiary checked:bg-blue-600 checked:border-blue-600 focus:outline-none"
                        type="checkbox"
                        checked={agreeToSubmitToBrs}
                        onChange={(e) =>
                          setAgreeToSubmitToBrs(e.target.checked)
                        }
                        id="flexCheckDefault"
                      />
                      <label
                        className="inline-block form-check-label text-tertiary"
                        htmlFor="flexCheckDefault"
                      >
                        I confirm that the Statutory Forms are in order and may
                        be submitted to the company promoters for signatures.
                      </label>
                    </div>
                  </div>
                </div>
              ) : (
                <p className="mt-4 text-center">No documents found</p>
              )}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Confirmation;
